import React, {useState} from "react";
import axios from "axios";
import "./Dictionary.css";
import Results from "./Results";
import Photos from "./Photos";

export default function Dictionary(props) {
    let [Keyword, setKeyword] = useState(props.defaultKeyword);
    let [results, setResults] = useState(null);
    let [loaded, setLoaded] = useState(false);
    let [photos, setPhotos] = useState(null);

    function handleResponse(response) {
        setResults(response.data[0])
    }

    function handlePexelsResponse(response) {
        setPhotos(response.data.photos);
      }

    function Search() {
        //documentation: https://dictionaryapi.dev/
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${Keyword}`;
    axios.get(apiUrl).then(handleResponse);

    let pexelsApiKey = "563492ad6f91700001000001f17f4b49f761425fab2dde8a91b24470";
    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${Keyword}&per_page=9`;
    let headers = { Authorization: `Bearer ${pexelsApiKey}` };
    axios.get(pexelsApiUrl, { headers: headers }).then(handlePexelsResponse);

    }

    function handleSubmit(event) {
    event.preventDefault();
    Search();

}


function handleKeywordChange(event) {
    setKeyword(event.target.value);
}

function load() {
    setLoaded(true);
    Search();
}


if  (loaded) {
return (
<div className="Dictionary">
    <section> 
    <form onSubmit={handleSubmit}>  
        <input type="search" 
        placeholder="Search for a word"
        onChange={handleKeywordChange} />  
     </form>
     <div className="hint">
      suggested words: sunset, yoga, forest, sea...

     </div>
     </section>
     <Results results={results}/>
     <Photos photos={photos} />
</div>
);
} else {
    load();
    return "Loading";
}
}
